app.views.planexplorer = app.views.base.extend({
  childEvents: {
    'change [data-amount]': '_onChangeAmountEventHandler'
  },
  globals: {
    minPlanAmount: 5,
    affordablePaymentAmount: 0,
    greaterWarningPaymentAmount: 0,
    amountOwed: 0,
    finalPaymentDate: null,
    planVariance: 'high',
    planTotal: 0,
    numberOfPayments: 0
  },
  constants: {
    owedValue: 'owed',
    affordableValue: 'afforded',
    incrementValue: 5,
    maxPlanInstallments: 999,
    increment: 'increment',
    decrement: 'decrement'
  },
  attr: {
    action: 'data-action',
    currencyAmount: 'data-currency-amount',
    inputClear: 'data-input-clear',
    adjustableAmount: 'data-adjustable-amount',
    affordableAmount: 'data-affordable-amount',
    owedAmount: 'data-owed-amount',
    spinner: 'data-form-spinner',
    finalPlanDate: 'data-final-plan-date',
    numberOfPayments: 'data-numberofpayments',
    basePlanMessage: 'data-base-message',
    greaterPlanMessage: 'data-greater-message',
    checkAffordableMessage: 'data-check-affordable-message',
    lesserPlanMessage: 'data-lesser-message',
    fasterPlanMessage: 'data-faster-message',
    minPlanMessage: 'data-min-message',
    minPartialPlanMessage: 'data-min-partial-plan-message',
    partialPlanMessage: 'data-partial-plan-message',
    affodabilityCalculator: 'data-affordability-calculator',
    decrementButton: 'data-decrement',
    incrementButton: 'data-increment',
    continueWithPlan: 'data-signin-plan',
    returnStep: 'data-back-button',
    validationError: 'data-valmsg-summary',
    progressBar: 'data-progress-bar',
    planLength: 'data-plan-length',
    planTotal: 'data-plan-total',
    balanceRemaining: 'data-balance-remaining',
    balanceRemainingOpenModal: 'data-open-remaining-balance',
    planLengthModal: 'data-plan-length-modal',
    balanceRemainingModal: 'data-remaining-balance-modal',
    totalBalanceModal: 'data-total-balance-modal'
  },
  settings: {
    dateFormat: 'MMMM YYYY',
    countryFormat: 'en-GB'
  },
  classes: {
    selectedPlanLength: '.selectedPlanLength'
  },
  init: function init() {
    this.initModals();
    this._initCurrencyFormat();
    this._initReturnAction();
    this._initPaymentDecrement();
    this._initPaymentIncrement();
    this._initRemainingBalanceModal();
    this._initClearInputs();
  },
  /**
  * The initialisation of the modal plugin.
  * @public
  */

  initModals: function initModals() {
    $('form').find('[data-modal]').each(function () {
      $(this).app_modals({
        closeOnBgClick: false
      });
    });
  },
  /**
  * Initalises Autonumeric on input fields
  * Listens for the amount field being changed and formats
  * @private
  */
  _initCurrencyFormat: function _initCurrencyFormat() {
    $('body').find('[' + this.attr.currencyAmount + ']').each(function () {
      new AutoNumeric(this, {
        vMax: '9999999.00',
        watchExternalChanges: true,
        minimumValue: 0
      });
    });
  },
  /**
  * Clears Inputs Listener
  * Adds Listener for clear icon on input fileds to be clicked to clear input
  * @private
  */
  _initClearInputs: function _initClearInputs() {
    var _this = this;
    $('body').find('[' + _this.attr.inputClear + ']').each(function () {
      var parent = $(this).parents('.input');
      var input = parent.find('input');
      $(this).bind('keypress', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          _this.onClearInput(e);
        }
      });
      $(this).on('click', function (e) {
        _this.onClearInput(e);
      });
      if (input.val()) {
        $(this).show();
      }
    });
  },
  /**
  * Clears Inputs
  * Updates for clear icon on input fileds to be clicked to clear input
  * @public
  */
  onClearInput: function onClearInput(e) {
    var parent = $(e.currentTarget).parents('.input');
    var input = parent.find('input');
    input.val('');
    $(e.currentTarget).hide();
    $('[' + this.attr.action + ']').prop('disabled', true);
    $('[' + this.attr.action + ']').addClass('disabled');
  },
  /**
   * Amount Change Event Hanlder
   * Listens for the amount field being changed.
   * Disables or enables the form action beased on the field value.
   * @private
   * @param {event} e : Action event
   */
  _onChangeAmountEventHandler: function _onChangeAmountEventHandler(e) {
    var input = $(e.currentTarget);
    var action = $('[' + this.attr.action + ']');
    var cleanedAmount = input.val().replace(/,/g, '');
    var amount = parseFloat(cleanedAmount);
    if (amount > 0 && amount < 1) {
      $(e.currentTarget).val(1 .toFixed(2));
    }
    if ($(e.currentTarget).attr(this.attr.currencyAmount) == this.constants.owedValue) {
      if (amount > 0) {
        $('[' + this.attr.inputClear + '="' + this.constants.owedValue + '"]').show();
      } else {
        $('[' + this.attr.inputClear + '="' + this.constants.owedValue + '"]').hide();
      }
    } else if ($(e.currentTarget).attr(this.attr.currencyAmount) == this.constants.affordableValue) {
      if (amount > 0) {
        $('[' + this.attr.inputClear + '="' + this.constants.affordableValue + '"]').show();
      } else {
        $('[' + this.attr.inputClear + '="' + this.constants.affordableValue + '"]').hide();
      }
    }
    var owedInput = $('[' + this.attr.currencyAmount + '="' + this.constants.owedValue + '"]');
    var amountOwed = parseFloat(owedInput.val().replace(/,/g, ''));
    var affordableInput = $('[' + this.attr.currencyAmount + '="' + this.constants.affordableValue + '"]');
    var amountAffordable = parseFloat(affordableInput.val().replace(/,/g, ''));
    if (!isNaN(amountAffordable) && amountAffordable > amountOwed) {
      affordableInput.val(amountOwed.toFixed(2));
    }
    if (!isNaN(amountOwed) && !isNaN(amountAffordable) && amountOwed > 0 && amountAffordable > 0) {
      action.prop('disabled', false);
      action.removeClass('disabled');
    } else {
      action.prop('disabled', true);
      action.addClass('disabled');
    }
    $('[' + this.attr.validationError + ']').remove();
  },
  /**
   * On Begin Progression Event
   * Fires on the start of changing a step.
   * @public
   */
  onBeginProgressionEvent: function onBeginProgressionEvent() {
    $('[' + this.attr.spinner + ']').show();
  },
  /**
  * On Progression Event
  * Listens for a step change.
  * @public
  * @param {data} response : the response from the controller.
  */
  onProgressionEvent: function onProgressionEvent(response) {
    if (response && response.nextRequestAjax === false) {
      window.location = window.location.origin + response.redirectUrl;
    } else {
      $('[' + this.attr.spinner + ']').hide();
    }
  },
  /**
   * On Complete Progression Event
   * Fires on the completion of an plan explorer step change.
   * @public
   */
  onCompleteProgressionEvent: function onCompleteProgressionEvent() {
    $('[' + this.attr.validationSummary + ']').find('ul').html('');
    if ($('#LowVariancePlanForm').length) {
      this._calculatePlanThreshholds();
    } else if ($('#HighVariancePlanForm').length) {
      this._calculatePlanVariables();
    }
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
    this.init();
  },
  /**
  * On Increment AffordableAmount
  * Listens for click event on plus icon to increment payment amount.
  * @private
  */
  _initPaymentIncrement: function _initPaymentIncrement() {
    var _this = this;
    $('body').find('[' + _this.attr.incrementButton + ']').each(function () {
      $(this).bind('keypress', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          _this.onIncrementAffordableAmount();
        }
      });
      $(this).on('click', function (e) {
        _this.onIncrementAffordableAmount();
      });
    });
  },
  /**
  * On Increment AffordableAmount
  * Updates UI based on user input to change monthly payment amount
  * @public
  */
  onIncrementAffordableAmount: function onIncrementAffordableAmount() {
    var currentAffordableAmount = parseFloat($('[' + this.attr.affordableAmount + ']').val().replace(/,/g, ''));
    var currentOwedAmount = parseFloat($('[' + this.attr.owedAmount + ']').val().replace(/,/g, ''));
    currentAffordableAmount = Math.round((currentAffordableAmount + this.constants.incrementValue) / 5) * 5;
    if (currentAffordableAmount <= currentOwedAmount) {
      $('[' + this.attr.adjustableAmount + ']').val('£' + currentAffordableAmount);
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAmount);
    } else {
      $('[' + this.attr.incrementButton + ']').addClass('disabled');
      $('[' + this.attr.incrementButton + ']').attr('disabled', true);
    }
    if (currentAffordableAmount == currentOwedAmount || currentAffordableAmount + this.constants.incrementValue > currentOwedAmount) {
      $('[' + this.attr.incrementButton + ']').addClass('disabled');
      $('[' + this.attr.incrementButton + ']').attr('disabled', true);
    } else {
      $('[' + this.attr.decrementButton + ']').removeClass('disabled');
      $('[' + this.attr.decrementButton + ']').removeAttr('disabled');
    }
    if ($('#LowVariancePlanForm').length) {
      this._evaluatePlanThreshholds(this.constants.increment);
    } else if ($('#HighVariancePlanForm').length) {
      this._evaluatePlanVariables(this.constants.increment);
    }
  },
  /**
  * On Decrement AffordableAmount Listener
  * Listens for click event on plus icon to decrement payment amount.
  * @private
  */
  _initPaymentDecrement: function _initPaymentDecrement() {
    var _this = this;
    $('body').find('[' + _this.attr.decrementButton + ']').each(function () {
      $(this).bind('keypress', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          _this.onDecrementAffordableAmount();
        }
      });
      $(this).on('click', function (e) {
        _this.onDecrementAffordableAmount();
      });
    });
  },
  /**
  * On Decrement AffordableAmount
  * Updates UI based on user input to change monthly payment amount
  * @public
  */
  onDecrementAffordableAmount: function onDecrementAffordableAmount() {
    var currentAffordableAmount = parseFloat($('[' + this.attr.affordableAmount + ']').val().replace(/,/g, ''));
    currentAffordableAmount = Math.round((currentAffordableAmount - this.constants.incrementValue) / 5) * 5;
    if (currentAffordableAmount > this.globals.minPlanAmount) {
      $('[' + this.attr.adjustableAmount + ']').val('£' + currentAffordableAmount);
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAmount);
      $('[' + this.attr.decrementButton + ']').removeClass('disabled');
      $('[' + this.attr.decrementButton + ']').removeAttr('disabled');
    } else {
      $('[' + this.attr.adjustableAmount + ']').val('£' + this.globals.minPlanAmount);
      $('[' + this.attr.affordableAmount + ']').val(this.globals.minPlanAmount);
      $('[' + this.attr.decrementButton + ']').addClass('disabled');
      $('[' + this.attr.decrementButton + ']').attr('disabled', true);
    }
    $('[' + this.attr.incrementButton + ']').removeClass('disabled');
    $('[' + this.attr.incrementButton + ']').removeAttr('disabled');
    if ($('#LowVariancePlanForm').length) {
      this._evaluatePlanThreshholds(this.constants.decrement);
    } else if ($('#HighVariancePlanForm').length) {
      this._evaluatePlanVariables(this.constants.decrement);
    }
  },
  /**
  * Calculate Plan Threshholds
  * Initialises values based on inital users declared affordable amount
  * @private
  */
  _calculatePlanThreshholds: function _calculatePlanThreshholds() {
    var currentAffordableAmount = parseFloat($('[' + this.attr.affordableAmount + ']').val().replace(/,/g, '').replace('£', ''));
    this.globals.greaterWarningPaymentAmount = currentAffordableAmount * 1.15; //15% greater that affordable amount entered

    var currentAffordableAdustedAmount = Math.round(currentAffordableAmount / 5) * 5;
    this.globals.affordablePaymentAmount = currentAffordableAmount;
    if (currentAffordableAmount >= this.globals.minPlanAmount) {
      $('[' + this.attr.adjustableAmount + ']').val('£' + currentAffordableAdustedAmount);
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAdustedAmount);
    } else {
      $('[' + this.attr.adjustableAmount + ']').val('£' + Math.round(currentAffordableAmount));
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAdustedAmount);
      $('[' + this.attr.basePlanMessage + ']').hide();
      $('[' + this.attr.minPlanMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
      $('[' + this.attr.continueWithPlan + ']').hide();
      $('[' + this.attr.decrementButton + ']').addClass('disabled');
      $('[' + this.attr.decrementButton + ']').attr('disabled', true);
    }
  },
  /**
  * Evaluate Plan Threshholds
  * Checks values to determine message to display to customer
  * @private
  */
  _evaluatePlanThreshholds: function _evaluatePlanThreshholds(type) {
    var newAffordableAmount = parseFloat($('[' + this.attr.affordableAmount + ']').val().replace(/,/g, ''));
    var currentOwedAmount = parseFloat($('[' + this.attr.owedAmount + ']').val().replace(/,/g, ''));
    var numberOfPayments = Math.ceil(currentOwedAmount / newAffordableAmount);
    if (numberOfPayments < 1200)
      //100 years
      {
        var currentPlanEndDate = moment().add(numberOfPayments - 1, 'months');
        var finalPaymentDate = currentPlanEndDate.format(this.settings.dateFormat);
        $('[' + this.attr.finalPlanDate + ']').html(finalPaymentDate);
      } else {
      $('[' + this.attr.finalPlanDate + ']').html('Not Available');
    }
    $('[' + this.attr.numberOfPayments + ']').html(numberOfPayments);
    $('[' + this.attr.continueWithPlan + ']').show();
    this._hideCustomerPromptMessages();
    if (newAffordableAmount > this.globals.affordablePaymentAmount && newAffordableAmount < this.globals.greaterWarningPaymentAmount) {
      if (type === this.constants.decrement) {
        $('[' + this.attr.fasterPlanMessage + ']').show();
      } else {
        $('[' + this.attr.greaterPlanMessage + ']').show();
      }
    } else if (newAffordableAmount > this.globals.affordablePaymentAmount && newAffordableAmount > this.globals.greaterWarningPaymentAmount) {
      $('[' + this.attr.checkAffordableMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
      $('[' + this.attr.fasterPlanMessage + ']').hide();
    } else if (newAffordableAmount < this.globals.affordablePaymentAmount && newAffordableAmount > this.globals.minPlanAmount) {
      if (type === this.constants.increment) {
        $('[' + this.attr.greaterPlanMessage + ']').show();
        $('[' + this.attr.affodabilityCalculator + ']').show();
      } else {
        $('[' + this.attr.lesserPlanMessage + ']').show();
        $('[' + this.attr.affodabilityCalculator + ']').show();
      }
    } else if (newAffordableAmount == this.globals.minPlanAmount) {
      $('[' + this.attr.minPlanMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
      $('[' + this.attr.continueWithPlan + ']').hide();
    } else if (newAffordableAmount == this.globals.affordablePaymentAmount) {
      $('[' + this.attr.basePlanMessage + ']').show();
      $('[' + this.attr.fasterPlanMessage + ']').hide();
    }
  },
  /**
  * Calculate Plan Variables
  * Initialises values based on inital users declared affordable amount
  * @private
  */

  _calculatePlanVariables: function _calculatePlanVariables() {
    var currentAffordableAmount = parseFloat($('[' + this.attr.affordableAmount + ']').val().replace(/,/g, ''));
    var currentOwedAmount = parseFloat($('[' + this.attr.owedAmount + ']').val().replace(/,/g, ''));
    this.globals.amountOwed = currentOwedAmount;
    this.globals.selectedPlanLength = '';
    var currentAffordableAdustedAmount = Math.round(currentAffordableAmount / 5) * 5;
    var numberOfPayments = Math.ceil(currentOwedAmount / currentAffordableAdustedAmount);
    var percentPlanCompletion = numberOfPayments < this.constants.maxPlanInstallments ? 100 : Math.round(this.constants.maxPlanInstallments / numberOfPayments * 100);
    var numberOfPaymentsStr = numberOfPayments > this.constants.maxPlanInstallments ? this.constants.maxPlanInstallments : numberOfPayments;
    var planTotal = Math.round(currentAffordableAmount / 5) * 5 * numberOfPaymentsStr;
    if (planTotal > currentOwedAmount) {
      planTotal = currentOwedAmount;
    }
    var balanceRemaining = this.globals.amountOwed - planTotal;
    balanceRemaining = balanceRemaining < 0 ? 0 : balanceRemaining;
    if (balanceRemaining > 0) {
      $('[' + this.attr.balanceRemainingOpenModal + ']').show();
    } else {
      $('[' + this.attr.balanceRemainingOpenModal + ']').hide();
    }
    var poundsUK = Intl.NumberFormat(this.settings.countryFormat);
    planTotal = poundsUK.format(planTotal);
    balanceRemaining = poundsUK.format(balanceRemaining);
    percentPlanCompletion = percentPlanCompletion + '%';
    $('[' + this.attr.progressBar + ']').css("width", percentPlanCompletion);
    $('[' + this.attr.numberOfPayments + ']').val(numberOfPaymentsStr);
    $('[' + this.attr.numberOfPayments + ']').html(numberOfPaymentsStr);
    $('[' + this.attr.planTotal + ']').html('£' + planTotal);
    $('[' + this.attr.balanceRemaining + ']').html('£' + balanceRemaining);
    this._initCarouselOptions(numberOfPaymentsStr);
    this.globals.affordablePaymentAmount = currentAffordableAmount;
    this.globals.greaterWarningPaymentAmount = currentAffordableAmount * 1.15; //15% greater that affordable amount entered

    if (currentAffordableAmount > this.globals.minPlanAmount && numberOfPayments <= this.constants.maxPlanInstallments) {
      $('[' + this.attr.adjustableAmount + ']').val('£' + currentAffordableAdustedAmount);
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAdustedAmount);
    } else if (numberOfPayments > this.constants.maxPlanInstallments && currentAffordableAmount > this.globals.minPlanAmount) {
      $('[' + this.attr.adjustableAmount + ']').val('£' + currentAffordableAdustedAmount);
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAdustedAmount);
      $('[' + this.attr.basePlanMessage + ']').hide();
      $('[' + this.attr.minPartialPlanMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
    } else {
      $('[' + this.attr.adjustableAmount + ']').val('£' + currentAffordableAmount);
      $('[' + this.attr.affordableAmount + ']').val(currentAffordableAmount);
      $('[' + this.attr.basePlanMessage + ']').hide();
      $('[' + this.attr.minPlanMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
      $('[' + this.attr.continueWithPlan + ']').hide();
      $('[' + this.attr.decrementButton + ']').addClass('disabled');
      $('[' + this.attr.decrementButton + ']').attr('disabled', true);
    }
  },
  /**
  * Evaluate Plan Variables
  * Checks values to determine message and values to display to customer on high variance plan
  * @private
  */
  _evaluatePlanVariables: function _evaluatePlanVariables(type) {
    var newAffordableAmount = parseFloat($('[' + this.attr.adjustableAmount + ']').val().replace(/,/g, '').replace('£', ''));
    var numberOfPayments = Math.ceil(this.globals.amountOwed / newAffordableAmount);
    var numberOfPaymentsStr = numberOfPayments > this.constants.maxPlanInstallments ? this.constants.maxPlanInstallments : numberOfPayments;
    var planTotal = this.globals.selectedPlanLength ? newAffordableAmount * this.globals.selectedPlanLength : newAffordableAmount * numberOfPaymentsStr;
    var percentPlanCompletion = Math.round(planTotal / this.globals.amountOwed * 100);
    if (planTotal > this.globals.amountOwed) {
      planTotal = this.globals.amountOwed;
      percentPlanCompletion = 100;
    }
    var balanceRemaining = this.globals.amountOwed - planTotal;
    balanceRemaining = balanceRemaining < 0 ? 0 : balanceRemaining;
    if (balanceRemaining > 0) {
      $('[' + this.attr.balanceRemainingOpenModal + ']').show();
    } else {
      $('[' + this.attr.balanceRemainingOpenModal + ']').hide();
    }
    var poundsUK = Intl.NumberFormat(this.settings.countryFormat);
    planTotal = poundsUK.format(planTotal);
    balanceRemaining = poundsUK.format(balanceRemaining);
    percentPlanCompletion = percentPlanCompletion + '%';
    $('[' + this.attr.progressBar + ']').css("width", percentPlanCompletion);
    $('[' + this.attr.balanceRemaining + ']').html('£' + balanceRemaining);
    $('[' + this.attr.planTotal + ']').html('£' + planTotal);
    this._initCarouselOptions(numberOfPaymentsStr);
    if (this.globals.selectedPlanLength && this.globals.selectedPlanLength <= numberOfPaymentsStr) {
      $('[' + this.attr.numberOfPayments + ']').val(this.globals.selectedPlanLength);
      $('[' + this.attr.numberOfPayments + ']').html(this.globals.selectedPlanLength);
    } else {
      $('[' + this.attr.numberOfPayments + ']').val(numberOfPaymentsStr);
      $('[' + this.attr.numberOfPayments + ']').html(numberOfPaymentsStr);
    }
    $('[' + this.attr.continueWithPlan + ']').show();
    this._hideCustomerPromptMessages();
    if (newAffordableAmount > this.globals.affordablePaymentAmount && newAffordableAmount < this.globals.greaterWarningPaymentAmount) {
      $('[' + this.attr.greaterPlanMessage + ']').show();
    } else if (newAffordableAmount > this.globals.affordablePaymentAmount && newAffordableAmount > this.globals.greaterWarningPaymentAmount) {
      $('[' + this.attr.checkAffordableMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
    } else if (newAffordableAmount < this.globals.affordablePaymentAmount && newAffordableAmount > this.globals.minPlanAmount) {
      if (type === this.constants.increment) {
        $('[' + this.attr.greaterPlanMessage + ']').show();
        $('[' + this.attr.affodabilityCalculator + ']').show();
      } else {
        $('[' + this.attr.lesserPlanMessage + ']').show();
        $('[' + this.attr.affodabilityCalculator + ']').show();
      }
    } else if (newAffordableAmount == this.globals.minPlanAmount) {
      $('[' + this.attr.minPlanMessage + ']').show();
      $('[' + this.attr.affodabilityCalculator + ']').show();
    } else if (newAffordableAmount == this.globals.affordablePaymentAmount && numberOfPayments <= this.constants.maxPlanInstallments) {
      $('[' + this.attr.basePlanMessage + ']').show();
    } else {
      $('[' + this.attr.minPartialPlanMessage + ']').show();
    }
  },
  /**
  * Back Button Navigation
  * Navigates back to PrePlan step
  * @public
  */
  onBackButton: function onBackButton() {
    $('[' + this.attr.adjustableAmount + ']').val(this.globals.affordablePaymentAmount);
    var backToPrePlan = $('form').append('<input type="hidden" name="progression" value="previous" />');
    backToPrePlan.submit();
    this.init();
    $('[' + this.attr.inputClear + '="' + this.constants.owedValue + '"]').show();
    $('[' + this.attr.inputClear + '="' + this.constants.affordableValue + '"]').show();
  },
  /**
  * Back Button Event Listener
  * Listens for action on back button
  * @public
  */
  _initReturnAction: function _initReturnAction() {
    var _this = this;
    $('body').find('[' + _this.attr.returnStep + ']').each(function () {
      $(this).bind('keypress', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          _this.onBackButton();
        }
      });
      $(this).on('click', function (e) {
        _this.onBackButton();
      });
    });
  },
  /**
  * Initialise Carousel for plan length options
  * Sets the options to pick on carosel based on current user input values
  * @private
  * @param {number} numberOfPayments : number of payments available to plan
  */
  _initCarouselOptions: function _initCarouselOptions(numberOfPayments) {
    var _this = this;
    var planYears = Math.floor(numberOfPayments / 12);
    var monthsRemainder = numberOfPayments % 12;
    this.globals.numberOfPayments = numberOfPayments;
    var carousel = $('.owl-carousel');
    var content = '';
    carousel.trigger('destroy.owl.carousel');
    carousel.find('.owl-stage-outer').children().unwrap();
    carousel.removeClass("owl-center owl-loaded owl-text-select-on");
    if (numberOfPayments <= 12) {
      for (var i = 0; i < numberOfPayments; i++) {
        content += '<div class="item" tabindex="0" data-plan-length="' + (i + 1) + '">' + (i + 1) + ' months</div>';
      }
    } else {
      content = '<div class="item" tabindex="0" data-plan-length="6"> 6 months</div>';
      for (var i = 1; i <= planYears; i++) {
        content += '<div class="item" tabindex="0" data-plan-length="' + i * 12 + '">' + i + ' years</div>';
      }
      if (monthsRemainder > 0) {
        content += '<div class="item" tabindex="0" data-plan-length="' + numberOfPayments + '" >' + planYears + ' years<br>';
        content += monthsRemainder + ' months ';
        content += '</div>';
      }
    }
    carousel.html(content);
    carousel.owlCarousel({
      items: 5,
      loop: false,
      dots: false,
      center: false
    });
    if (this.globals.selectedPlanLength && this.globals.selectedPlanLength <= numberOfPayments) {
      var item = $(carousel).find("[data-plan-length='" + this.globals.selectedPlanLength + "']");
      item.addClass("selectedPlanLength");
    } else {
      $(carousel).find('.item').last().addClass("selectedPlanLength");
    }
    $(carousel).trigger('to.owl.carousel', [numberOfPayments, 1, true]);
    $(carousel).find('.item:first').each(function () {
      $(this).focus(function () {
        $(carousel).trigger('to.owl.carousel', [0, 1, true]);
      });
    });
    $(carousel).find('.item').each(function () {
      $(this).bind('keypress', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          if ($(this).hasClass('selectedPlanLength') == false) {
            $('.owl-carousel').find(_this.classes.selectedPlanLength).removeClass('selectedPlanLength');
            $(this).addClass('selectedPlanLength');
            _this.globals.selectedPlanLength = $(this).attr('data-plan-length');
            _this._onPlanLengthChange();
          }
        }
      });
      $(this).on('click', function (e) {
        if ($(this).hasClass('selectedPlanLength') == false) {
          $('.owl-carousel').find(_this.classes.selectedPlanLength).removeClass('selectedPlanLength');
          $(this).addClass('selectedPlanLength');
          _this.globals.selectedPlanLength = $(this).attr('data-plan-length');
          _this._onPlanLengthChange();
        }
      });
    });
    $(this).on('keydown', function (event) {
      if (event.keyCode == 37) {
        $(carousel).trigger('prev.owl.carousel');
      }
      if (event.keyCode == 39) {
        $(carousel).trigger('next.owl.carousel');
      }
    });
  },
  /**
  * On Plan length change
  * Sets the options to picked value and update other values accordingly
  * @private
  */
  _onPlanLengthChange: function _onPlanLengthChange() {
    var planLengthPicked = $(this.classes.selectedPlanLength);
    var numberOfPayments = planLengthPicked.attr(this.attr.planLength);
    numberOfPayments = numberOfPayments > this.constants.maxPlanInstallments ? this.constants.maxPlanInstallments : numberOfPayments;
    var paymentAmount = $('[' + this.attr.adjustableAmount + ']').val().replace(/,/g, '').replace('£', '');
    var planTotal = paymentAmount * numberOfPayments;
    var balanceRemaining = this.globals.amountOwed - planTotal;
    balanceRemaining = balanceRemaining < 0 ? 0 : balanceRemaining;
    if (planTotal > this.globals.amountOwed) {
      planTotal = this.globals.amountOwed;
    }
    if (balanceRemaining > 0) {
      $('[' + this.attr.balanceRemainingOpenModal + ']').show();
    } else {
      $('[' + this.attr.balanceRemainingOpenModal + ']').hide();
    }
    var planCompletion = planTotal / this.globals.amountOwed * 100;
    var planCompletionPercentage = planCompletion + '%';
    if (planCompletion > 100) {
      planCompletionPercentage = 100 + '%';
    }
    var poundsUK = Intl.NumberFormat(this.settings.countryFormat);
    planTotal = poundsUK.format(planTotal);
    balanceRemaining = poundsUK.format(balanceRemaining);
    $('[' + this.attr.numberOfPayments + ']').val(numberOfPayments);
    $('[' + this.attr.numberOfPayments + ']').html(numberOfPayments);
    $('[' + this.attr.planTotal + ']').html('£' + planTotal);
    $('[' + this.attr.balanceRemaining + ']').html('£' + balanceRemaining);
    $('[' + this.attr.progressBar + ']').css("width", planCompletionPercentage);
    this._hideCustomerPromptMessages();
    if (this.globals.numberOfPayments > numberOfPayments) {
      $('[' + this.attr.minPartialPlanMessage + ']').show();
    }
    if (this.globals.numberOfPayments < numberOfPayments) {
      $('[' + this.attr.partialPlanMessage + ']').show();
    }
    this.globals.numberOfPayments = numberOfPayments;
  },
  /**
  * Remaining Balance Modal Event Listener
  * Listens for action on back button
  * @private
  */
  _initRemainingBalanceModal: function _initRemainingBalanceModal() {
    var _this = this;
    $('body').find('[' + _this.attr.balanceRemainingOpenModal + ']').each(function () {
      $(this).bind('keypress', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          _this.openRemainingBalanceModal();
        }
      });
      $(this).on('click', function (e) {
        _this.openRemainingBalanceModal();
      });
    });
  },
  /**
  * Remaining Balance Modal Details
  * Sets modal values to be displayed
  * @private
  */
  _setRemainingBalanceDetails: function _setRemainingBalanceDetails() {
    var planLegth = $(this.classes.selectedPlanLength).html();
    var remainingBalance = $('[' + this.attr.balanceRemaining + ']').html();
    var totalBalance = this.globals.amountOwed;
    var poundsUK = Intl.NumberFormat(this.settings.countryFormat);
    totalBalance = poundsUK.format(totalBalance);
    $('[' + this.attr.planLengthModal + ']').html(planLegth);
    $('[' + this.attr.balanceRemainingModal + ']').html(remainingBalance);
    $('[' + this.attr.totalBalanceModal + ']').html('£' + totalBalance);
  },
  /**
  * Hide Customer messages
  * Hides customer messages on UI
  * @private
  */
  _hideCustomerPromptMessages: function _hideCustomerPromptMessages() {
    $('[' + this.attr.greaterPlanMessage + ']').hide();
    $('[' + this.attr.basePlanMessage + ']').hide();
    $('[' + this.attr.lesserPlanMessage + ']').hide();
    $('[' + this.attr.minPlanMessage + ']').hide();
    $('[' + this.attr.checkAffordableMessage + ']').hide();
    $('[' + this.attr.affodabilityCalculator + ']').hide();
    $('[' + this.attr.partialPlanMessage + ']').hide();
    $('[' + this.attr.minPartialPlanMessage + ']').hide();
  },
  /**
  * Open Remaining Balance Modal
  * Opens modal showing the outstanding balance from current plan settings
  * @private
  */
  openRemainingBalanceModal: function openRemainingBalanceModal(url, type) {
    var _this = this;
    $.magnificPopup.close();
    var options = $.extend(app.options.modal(), {
      items: {
        type: "ajax",
        src: "/plan-explorer/remaining-balance"
      },
      callbacks: {
        open: function open() {
          $.magnificPopup.instance.wrap[0].addEventListener('focus', function () {
            app.initElementListeners($('.modal'));
            $('.mfp-content').attr('id', 'Modal');
            $('[data-modal-close]').on('click', function () {
              $.magnificPopup.close();
            });
            $('[data-modal-close]').keydown(function (e) {
              e.preventDefault();
              if (e.keyCode === 32) {
                $.magnificPopup.close();
              }
            });
            _this._setRemainingBalanceDetails();
          });
        }
      }
    });
    $.magnificPopup.open(options);
  }
});